import {post} from "../http"

export async function cancel(paymentArrangementID: string) {
	return await post(`/app/payment-arrangements/${paymentArrangementID}/cancel`)
}
